import React from 'react';
import { Typography, Grid } from '@mui/material';

const TabTwo = () => {
  return (
    <Grid
      paddingRight={'20px'}
      paddingLeft={'20px'}
      container
      xs={12}
      flexDirection={'column'}
      alignItems={'center'}
    >
      <Grid
        item
        flexDirection={'row'}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        width={'100%'}
      >
        <Typography
          paddingRight={'20px'}
          paddingLeft={'20px'}
          marginTop={'20px'}
          variant={'subtitle2'}
          textAlign={'left'}
        >
          تعداد کل:{'test'}
        </Typography>
        <Typography
          paddingRight={'20px'}
          paddingLeft={'20px'}
          marginTop={'20px'}
          variant={'subtitle2'}
          textAlign={'left'}
        >
          امروز
        </Typography>
      </Grid>
      <Grid
        item
        flexDirection={'row'}
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        width={'100%'}
      ></Grid>
    </Grid>
  );
};

export default TabTwo;
